//Used for displaying row colors

import { EEOccupationalLevel, WorkForceGoalAndTargetRow } from "../../../Component/Model/Enum/EmploymentEquity";

export interface IGoalAndTargetRow {
    id: WorkForceGoalAndTargetRow;
    label: string;

    scorecardId: string;

    maleAfricanValue: number;
    maleColouredValue: number;
    maleIndianValue: number;
    maleWhiteValue: number;

    femaleAfricanValue: number;
    femaleColouredValue: number;
    femaleIndianValue: number;
    femaleWhiteValue: number;

    maleForeignNationalValue: number;
    femaleForeignNationalValue: number;

    occupationalLevel : EEOccupationalLevel;
    isDisabled: boolean;
}

interface WorkForceGoalAndTargetRowLookupItem {
    Name: string;
    Level : EEOccupationalLevel;
}
export const WorkForceGoalAndTargetRowLookup: WorkForceGoalAndTargetRowLookupItem[] = [
    {Name : 'TopManagement' , Level: EEOccupationalLevel.Top_Management},
    {Name : 'SeniorManagement' , Level : EEOccupationalLevel.Senior_Management},
    {Name : 'MiddleManagement' , Level : EEOccupationalLevel.Middle_Management},
    {Name : 'JuniorManagement' , Level : EEOccupationalLevel.Junior_Management},
    {Name : 'SemiSkilled' , Level : EEOccupationalLevel.Semi_Skilled},
    {Name : 'Unskilled' , Level : EEOccupationalLevel.Unskilled},
    {Name : 'Temporary' , Level : EEOccupationalLevel.Temporary}
 ];
  
 export const WorkForceGoalAndTargetRowLookupValue = (lookupValue: EEOccupationalLevel) => {
    let item = WorkForceGoalAndTargetRowLookup.find(x => x.Level === lookupValue);
    if (item == null){
        return '';
    }else{
        return item.Name;
    }
 }